import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  jsonLd?: object[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, keywords, jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    const prev = document.querySelectorAll("script[data-seo-jsonld]");
    prev.forEach((n) => n.remove());

    if (jsonLd && jsonLd.length) {
      jsonLd.forEach((data) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo-jsonld", "");
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
      });
    }

    return () => {
      const cleanup = document.querySelectorAll("script[data-seo-jsonld]");
      cleanup.forEach((n) => n.remove());
    };
  }, [title, description, keywords, jsonLd]);

  return null;
}